export default __webpack_public_path__ + "a463d27952cd04abd686544ab9f94708.png";